/**
  * 用户 接口的统一出口
  */
 import axios from '../http' // 导入http中创建的axios实例
 import qs from 'qs' // 根据需求是否导入qs模块，把请求字段直接映射过来
 
 const index = {
    // 历史的今天分类
    cateList (params) {
        return axios.get('/home/historycate/list', { params: params })
    },
	// 历史的今天列表
	hisotryList (params) {
		return axios.get('/home/history/list', { params: params })
	},
	// 详情
	hisotryInfo (params) {
		return axios.get('/home/history/info', { params: params })
	},
	// 添加评论
	createComment (params) {
		return axios.get('/home/historycomment/create', { params: params })
	},
	// 发送道具
	sendFlower (params) {
		return axios.post('/home/history/senddaoju', qs.stringify(params))
	},
	// 评论列表
	commentList (params){
		return axios.post('/home/historycomment/list', qs.stringify(params))
	},
	// 点赞
	like (params){
		return axios.post('/home/history/like', qs.stringify(params))
	},
	// 漂流瓶 信息列表
	lovedriftList(params){
		return axios.get('/home/lovedrift/list', { params: params })
	},
	// 漂流瓶 信息详情
	lovedriftInfo(params){
		return axios.get('/home/lovedrift/info', { params: params })
	},
	// 漂流瓶 发布信息
	lovedriftCreate(params){
		return axios.post('/home/lovedrift/create', qs.stringify(params))
	},
	// 漂流瓶 修改信息
	lovedriftEdit(params){
		return axios.post('/home/lovedrift/edit', qs.stringify(params))
	},
	// 漂流瓶 添加评论
	lovedriftComment(params){
		return axios.post('/home/lovedriftcomment/create', qs.stringify(params))
	},
	// 漂流瓶 点赞
	lovedriftLike(params){
		return axios.post('/home/lovedrift/like', qs.stringify(params))
	},
	// 漂流瓶 删除
	lovedriftDel(params){
		return axios.post('/home/lovedrift/remove', qs.stringify(params))
	},
	// 获取海报
	sharePoster(params){
		return axios.get('/home/history/share', { params: params })
	}
 }
 
 // 导出接口
 export default index